import { getActiveRoute } from 'src/core/settings';
import { Hosting } from 'src/core/ahp';

import { IRegion, IRoute } from'../../../dip/library/di-hnf/di-hnf.js';
import { IView } from'../../../pip/library/pi-interop/pi-interop.js';
import f1 from'../../../pip/library/pi-f1/pi-f1.js';

type t_uri = string;
type THierarchyStep = {
  uri: string;
  title: string;
};

type TUriTree = {
  children: TUriTree[];
  regions: IRegion[];
  goto_uri: string;
  title?: string;
  uri: string;
};

// REPLACE (hip-ts)
interface IHierarchyNavigationNavigationItems extends HTMLElement {
  steps: THierarchyStep[];
}

// REPLACE (hip-ts)
declare global {
  interface Window {
    ['HIP']: any;
  }
}

export class HierarchyMenuViewRC implements IView {
  id = 'hierarchy-menu';
  ns = 'ahp';

  region: HTMLElement;

  constructor(public ahp: Hosting) {}

  mount(region: HTMLElement) {
    const navEl = document.createElement('hi-navigation-hierarchy');
    // const homeRoutePath = this.ahp.routing.configuration.paths.routes.authenticated;
    const homeRoutePath = this.ahp.navigation.configuration.paths.routes.authenticated;

    navEl.setAttribute('show-history-controls', 'true');
    navEl.setAttribute('root-uri', homeRoutePath);
    region.appendChild(navEl);

    return Promise.resolve(this);
  }

  stateChange() {
    const navEls = document.querySelectorAll('hi-navigation-hierarchy');
    if (navEls.length <= 0) {
      return Promise.resolve(this);
    }

    const navEl = navEls[0] as IHierarchyNavigationNavigationItems;
    navEl.steps = this.__calculateHierarchyNavigationResources();

    return Promise.resolve(this);
  }

  private __calculateHierarchyNavigationResources() {
    // @todo walk the tree of routes from Micro
    const hostingMicro = this.ahp.navigation.micro;
    const routing = hostingMicro.configuration.routes;

    const routeTree = hostingMicro.generateRouteTree(routing);

    // this.ahp.routing.shell.configuration.read('navigation_resources');
    const navResources = f1.safe([] as IRoute[], routeTree.routes);
    if (!navResources) {
      return [];
    }

    const getRoutes: t_uri[] = getActiveRoute()
      .split('/')
      .filter((o) => o);

    const getUriTree = f1.compact(f1.map((u) => this.__getUri(u), navResources));
    const getRoutesCombination: t_uri[] = [];
    let currentRoute = '';

    const n = getRoutes.length;
    for (let i = 0; i < n; i++) {
      currentRoute = `${currentRoute}/${getRoutes[i]}`;
      getRoutesCombination.push(currentRoute);
    }

    return this.__buildHierarchy(getRoutesCombination, getUriTree);
  }

  private __getUri(navResource: IRoute): TUriTree[] {
    if (navResource == null) {
      return [];
    }

    if (navResource.routes == null) {
      return [
        {
          uri: navResource.uri,
          title: navResource.title,
          goto_uri: navResource.goto_uri || '',
          regions: f1.safe([] as IRegion[], navResource.regions),
          children: []
        }
      ];
    }

    return navResource.routes.map((resource) => {
      const _resource = { ...resource };
      if (navResource.uri != null) {
        _resource.uri = (navResource.uri + _resource.uri).replace(/:\w+/g, '[\\w-]+');
      }

      const children = _resource.routes == null ? [] : this.__getUri(_resource);

      return {
        goto_uri: _resource.goto_uri || '',
        regions: _resource.regions,
        title: _resource.title,
        uri: _resource.uri,
        children
      };
    });
  }

  private __buildHierarchy(getRoutesCombination: t_uri[], getUriTree: any) {
    const matchUriWithRoute = (arr: any, activeRouteUri: string) =>
      arr.reduce((accumulator: TUriTree, uriTreeRoute: TUriTree) => {
        if (accumulator) {
          return accumulator;
        } else if (activeRouteUri.match(uriTreeRoute.uri + '$')) {
          return uriTreeRoute;
        } else if (uriTreeRoute['children'].length !== 0) {
          return matchUriWithRoute(uriTreeRoute['children'], activeRouteUri);
        }
      }, null);

    const flattenedArray = [].concat(
      ...getUriTree.map((e: Record<string, string>) => (e.hasOwnProperty('length') ? e : [e]))
    );

    return this.__getHierarchySteps(getRoutesCombination, flattenedArray, matchUriWithRoute);
  }

  private __getHierarchySteps(
    getRoutesCombination: t_uri[],
    flattenedArray: t_uri[],
    matchUriWithRoute: (a: t_uri[], b: string) => Record<string, string>
  ) {
    const hierarchySteps: THierarchyStep[] = [];
    let collectUri: Record<string, string>;

    const routesCombinationSize = getRoutesCombination.length;
    for (let i = 0; i < routesCombinationSize; i++) {
      collectUri = matchUriWithRoute(flattenedArray, getRoutesCombination[i]);
      if (collectUri == null) {
        continue;
      }

      if (
        collectUri.uri != null &&
        collectUri.title != null &&
        (collectUri.goto_uri != null || collectUri.regions != null)
      ) {
        let completeUri = collectUri.uri + collectUri.goto_uri;
        const uriList = completeUri.split('/');
        const getLastRouteCombinationList = getRoutesCombination[routesCombinationSize - 1].split('/');
        const lastRouteCombinationListSize = getLastRouteCombinationList.length;
        const regexForVariablesInGoToUri = /:\w+/;
        const regexForVariablesInUri = /\\w+/;

        let foundIndex = uriList.findIndex(
          (uri) => regexForVariablesInGoToUri.test(uri) || regexForVariablesInUri.test(uri)
        );

        while (foundIndex && foundIndex > 0 && foundIndex + 1 <= lastRouteCombinationListSize) {
          uriList[foundIndex] = getLastRouteCombinationList[foundIndex];
          foundIndex = uriList.findIndex(
            (uri) => regexForVariablesInGoToUri.test(uri) || regexForVariablesInUri.test(uri)
          );
        }

        completeUri = uriList.join('/');
        hierarchySteps.push({
          uri: '#' + completeUri,
          title: collectUri.title
        });
      }
    }

    return hierarchySteps;
  }
}
